import { ICreatorSearchFilters } from '../models';
import { ITextSearchAction, TextSearchActionTypes } from './textSearchActions';

const initialState: ICreatorSearchFilters = null;

export const textSearchReducer: Redux.Reducer<ICreatorSearchFilters> = (
  state = initialState,
  action: ITextSearchAction,
) => {
  switch (action.type) {
    case TextSearchActionTypes.UPDATE_SEARCH_FILTERS:
      return {
        ...state,
        ...action.payload.searchFilters,
      };

    default:
      return state;
  }
};
